module.exports = __webpack_public_path__ + "assets/img/live19_app.9a305824.png";